<template>
  <section id="mainContainer">
    <section class="login-page">
      <div class="login-container">
        <div class="admin-white-bg admin-custom-row">
          <div class="admin-login-left">
            <div class="admin-logo">
              <img src="@/assets/images/logo.svg" alt="Logo" />
            </div>
            <h1>{{ constants.LOGIN_TEXT }}</h1>
            <div class="admin-login-form">
              <form id="forgotLoginForm" @submit.prevent="login">
                <div class="login-input">
                  <label>{{ constants.EMAIL_LABEL }}</label>
                  <input type="text" id="loginEmailInput" placeholder="Enter Email address" v-model="email" />
                  <div class="error-msg" v-if="!email||errorMsg==='Please enter a valid Email'">{{errorMsg}}</div>
                </div>
                <div class="login-input">
                  <label>{{ constants.PASSWORD_LABEL }}</label>
                  <input type="password" id="loginPwtInput" placeholder="Password" v-model="password" />
                  <div class="error-msg" v-if="!password||errorMsg==='Please enter a valid Password'">{{errorMsg}}</div>
                
                </div>
                <div class="login-input-row">
                  <div class="remember-me-box">
                    <input name="cssCheckbox" id="loginRmrInput" type="checkbox" class="css-checkbox"
                      v-model="rememberMe" />
                    <label for="loginRmrInput">{{ constants.REMEMBER_ME_LABEL }}</label>
                  </div>
                  <div class="right-txt-link">
                    <a id="loginFpLink" @click.prevent="$router.push('/authority/forgot-password')">{{ constants.FORGOT_PASSWORD_LINK }}</a>
                  </div>
                </div>
                <button id="loginSubmitBtn" class="primary-btn" type="submit">{{ constants.LOGIN_BUTTON }}</button>
              </form>
            </div>
          </div>
          <div class="admin-login-right">
            <div class="admin-login-right-in">
              <span>{{ constants.WELCOME_TO_TEXT }}</span>
              <h2>{{ constants.LMD_CONSULTING_TEXT }}</h2>
              <p>{{ constants.LOGIN_TO_ACCESS_DASHBOARD_TEXT }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">
        {{ constants.COPYRIGHT_TEXT }}
      </div>
    </footer>
  </section>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import constants from '@/utils/en-US-Admin.json';
import { API_BASE_URL } from '@/config/api.config';
import axios from 'axios';
import Swal from 'sweetalert2';

export default defineComponent({
  name: 'Login',
  data() {
    return {
      constants,
      email: '',
      password: '',
      rememberMe: false,
      submitClicked: false,
      errorMsg: '',
      titleErrorUsername: false,
      titleErrorPassword: false,
    }
  },
  watch: {
    username() {
      if (this.submitClicked) {
        this.titleErrorUsername = !this.email;
        if (this.errorMsg !== constants.INVALID_EMAIL || this.errorMsg !== constants.INVALID_PASSWORD) {
          this.errorMsg = constants.THIS_FIELD_IS_REQUIRED;
        }
      }
    },
    password() {
      if (this.submitClicked) {
        this.titleErrorPassword = !this.password;
        if (this.errorMsg !== constants.INVALID_EMAIL || this.errorMsg !== constants.INVALID_PASSWORD) {
          this.errorMsg = constants.THIS_FIELD_IS_REQUIRED;
        }
      }
    },
  },

  mounted() {
    if (localStorage.getItem('isLoggedIn') === 'true') {
      this.$router.push('/authority/profile');
    } else {
      localStorage.clear();
    }
  },

  methods: {
    async login() {
      this.submitClicked = true;
      if (!this.email) {
        this.titleErrorUsername = true;
        this.errorMsg = constants.THIS_FIELD_IS_REQUIRED;
      } else {
        this.titleErrorUsername = false;
      }
      if (!this.password) {
        this.titleErrorPassword = true;
        this.errorMsg = constants.THIS_FIELD_IS_REQUIRED;
      } else {
        this.titleErrorPassword = false;
      }
      if (!this.email || !this.password) {
        return;
      }
      try {
        const response = await axios.post(`${API_BASE_URL}/adminLogin/`, {
          UserEmail: this.email,
          password: this.password
        });
        const tokens = response.data;

        localStorage.setItem('accessToken', tokens.access);
        localStorage.setItem('refreshToken', tokens.refresh);
        localStorage.setItem('firstname', tokens.first_name);
        localStorage.setItem('isLoggedIn', "true");
        localStorage.setItem('email', tokens.email);
        localStorage.setItem('profile_image', tokens.image);
        localStorage.setItem('lastname', tokens.last_name);
        localStorage.setItem('admin_id', tokens.admin_id);
        Swal.fire({
          icon: 'success',
          title: 'Login successful!',
          showConfirmButton: false,
          timer: 1500
        });

        this.$router.push('/authority/profile');
      } catch (error: any) {
        if (error.response) {
          if (error.response.data.error === 'Invalid Email') {
            this.titleErrorUsername = true;
            this.errorMsg ='Please enter a valid Email';
          } else if (error.response.data.error === 'Invalid Password') {
            this.titleErrorPassword = true;
            this.errorMsg = 'Please enter a valid Password';
          } else {
            this.titleErrorUsername = true;
            this.titleErrorPassword = true;
            this.errorMsg = "Invalid Credentials";
          }
        }
      }
    }
  }
});
</script>
